import isNil from "lodash/isNil";
import type { AgentResponse, MessageAuthor, OutgoingFrame } from "PFTypes/propilot";

import { GenericVariant } from "../../variants/generic/generic_variant";
import { VARIANT_BY_TYPE } from "../../variants/select_variant";
import { OptionsFacet } from "../facets/options/options_facet";
import { TextFacet } from "../facets/text/text_facet";
import { ProPilotSystemErrorBubble } from "../propilot_system_error_bubble";
import css from "./message_renderer.module.scss";

type OptionReplyFrame = Extract<OutgoingFrame, { kind: "option_reply" }>;

type MessageRendererProps = {
  message: AgentResponse;
  author: MessageAuthor;
  onOptionSelected: (frame: OptionReplyFrame) => void;
  onRetry?: () => void;
};

export const MessageRenderer = ({ message, author, onOptionSelected, onRetry }: MessageRendererProps) => {
  if (message.type === "system_error") {
    return <ProPilotSystemErrorBubble text={message.text ?? ""} onRetry={onRetry} />;
  }

  const hasText = !isNil(message.text);
  const hasOptions = author === "agent" && Array.isArray(message.options) && message.options.length > 0;

  if (!hasText && !hasOptions) {
    return null;
  }

  const Envelope = VARIANT_BY_TYPE[message.type] ?? GenericVariant;

  return (
    <div className={css.messageRenderer}>
      {hasText && (
        <Envelope author={author}>
          <TextFacet text={message.text!} />
        </Envelope>
      )}
      {/* Options sit outside the bubble so they appear below the message, not inside the blue box. */}
      {hasOptions && <OptionsFacet options={message.options!} onOptionSelected={onOptionSelected} />}
      {/* TODO: [SP-10327] render effects facet */}
    </div>
  );
};
